import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import bgImage from "../../src/assets/image/png/image3.webp"; // replace with your background image
import vastaImg from "../assets/image/png/vastaLogo.png"

const ImageSection = () => {
  return (
    <section id="about"
      className="d-flex image-section px-4 align-items-center justify-content-center text-center text-white"
      style={{
        backgroundImage: `url(${bgImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        position: "relative",
      }}
    >
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(0,0,0,0.5)",
        }}
      ></div>

      {/* Content */}
      <div className="position-relative">
       {/* <img className="w-100" style={{maxWidth:"700px"}} src={vastaImg} alt="vastaImg" /> */}
        <p className="mt-3 fs_30 mt-4">
          Discover & book Automotive, Salons, Spas, Sports Grounds<br className="d-md-block d-none"></br>  & more, all in one app.
        </p>
      </div>
    </section>
  );
};

export default ImageSection;
